<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/placement/${inputs.id}`
						: `transaction/placement`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_first_name" class="col-sm-3 mb-0">
						First Name
					</label>
					<app-input
						id="inputs_first_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.first_name"
						placeholder="First Name"
						:disabled="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_last_name" class="col-sm-3 mb-0">
						Last Name
					</label>
					<app-input
						id="inputs_last_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.last_name"
						placeholder="Last Name"
						:disabled="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_of_birth" class="col-sm-3 mb-0">
						Date of Birth
					</label>
					<app-input
						id="inputs_date_of_birth"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_of_birth"
						placeholder="Date of Birth"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						CLC Centre
					</label>
					<app-input
						id="inputs_center_id"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center_id"
						@input="setCenterIdValue"
						fetch-url="master/center"
						class="col-sm-9"
						placeholder="CLC Centre"
						list-value-field="name"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_course_type_id" class="col-sm-3 mb-0">
						Class Type
					</label>
					<app-input
						id="inputs_course_type_id"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_course_type_id"
						@input="setCourseTypeIdValue"
						fetch-url="master/course-type"
						class="col-sm-9"
						placeholder="Class Type"
						list-value-field="course_type_name"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_course_id" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_course_id"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_course_id"
						@input="setCourseIdValue"
						fetch-url="transaction/course"
						class="col-sm-9"
						placeholder="Class Name"
						list-value-field="course_name"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_production_status_id"
						class="col-sm-3 mb-0"
					>
						Production Status
					</label>
					<app-input
						id="inputs_production_status_id"
						type="search-select"
						v-model="inputs.production_status_id"
						:list="productionStatusList"
						fetch-url="transaction/course"
						class="col-sm-9"
						placeholder="Production Status"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_student_care_id" class="col-sm-3 mb-0">
						Student Care
					</label>
					<app-input
						id="inputs_student_care_id"
						class="col-sm-9"
						type="search-select"
						:list="studentCareIdLists"
						v-model="inputs.student_care_id"
						:placeholder="'Student Care'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_teach_id" class="col-sm-3 mb-0">
						Main Teacher
					</label>
					<app-input
						id="inputs_teach_id"
						class="col-sm-9"
						type="search-select"
						:list="teachIdLists"
						v-model="inputs.teach_id"
						:placeholder="'Main Teacher'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_last_modified" class="col-sm-3 mb-0">
						Last Modified
					</label>
					<app-input
						id="inputs_last_modified"
						class="col-sm-9"
						type="date"
						v-model="inputs.updated_at"
						placeholder="Last Modified"
						:disabled="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { PlacementListFormMixin } from "./PlacementListFormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";

export default {
	name: "PlacementListForm",
	mixins: [PlacementListFormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
			},
			input_course_id: this.value
				? this.value.course
					? {
							id: this.value.course.id || 0,
							course_name: this.value.course.course_name || "",
							is_active: this.value.course.is_active,
					  }
					: {
							id: this.value.course?.id || 0,
							course_name: this.value.course?.course_name || "",
							is_active: this.value.course?.is_active,
					  }
				: {
						id: this.value.course.id || 0,
						course_name: this.value.course.course_name || "",
						is_active: this.value.course.is_active,
				  },
			input_course_type_id: this.value
				? this.value.course_type
					? {
							id: this.value.course_type.id || 0,
							course_type_name:
								this.value.course_type.course_type_name || "",
							is_active: this.value.course_type.is_active,
					  }
					: {
							id: this.value.course_type?.id || 0,
							course_type_name:
								this.value.course_type?.course_type_name || "",
							is_active: this.value.course_type?.is_active,
					  }
				: {
						id: this.value.course_type.id || 0,
						course_type_name:
							this.value.course_type.course_type_name || "",
						is_active: this.value.course_type.is_active,
				  },
			input_center_id: this.value
				? this.value.center
					? {
							id: this.value.center.id || 0,
							name: this.value.center.name || "",
							is_active: this.value.center.is_active,
					  }
					: {
							id: this.value.center?.id || 0,
							name: this.value.center?.name || "",
							is_active: this.value.center?.is_active,
					  }
				: {
						id: this.value.center.id || 0,
						name: this.value.center.name || "",
						is_active: this.value.center.is_active,
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
			clcCentreList: [],
			subStatusLists: [],
			productionStatusList: [
				{ id: 1, value: "Orientation" },
				{ id: 2, value: "New" },
				{ id: 3, value: "Continuing Student" },
				{ id: 4, value: "Reactive" },
				{ id: 5, value: "Transfer" },
				{ id: 6, value: "Waiting" },
			],
			studentCareIdLists: [],
			teachIdLists: [],
		};
	},
	created() {
		console.log(`DATA: `);
		console.log(this.data)

		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [userResponse, centerResponse, leadStatusResponse] =
					await Promise.all([
						axios.get("/user-list?per_page=50"),
						axios.get("/master/center?is_active=true&per_page=50"),
						axios.get(
							"/master/lead-status?lead_status_id=3&per_page=50"
						),
					]);

				userResponse.data.data.forEach((item) => {
					this.studentCareIdLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.teachIdLists.push({
						id: item.id,
						value: item.full_name,
					});
				});

				centerResponse.data.data.forEach((item) => {
					this.clcCentreList.push({
						id: item.id,
						value: item.name,
					});
				});

				this.subStatusLists = leadStatusResponse.data.data.map(
					(item) => ({
						id: item.id,
						value: item.status,
					})
				);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.first_name = response.data.lead.name;
			this.inputs.last_name = response.data.lead.surname;
			this.inputs.date_of_birth = response.data.lead.date_of_birth;
			this.preloader = false;
		},

		setCourseIdValue(data) {
			this.inputs.course_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_id = data.id;
			}
		},
		setCourseTypeIdValue(data) {
			this.inputs.course_type_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_type_id = data.id;
			}
		},
		setCenterIdValue(data) {
			this.inputs.center_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		},
	},
};
</script>
